import { DropdownOptionDefaultContent } from "./DropdownOptionDefaultContent";
import { ButtonPreset } from "@/constants/componentPresets";
import { Cbutton } from "../Cbutton";
import { DropdownOptionHoverIndicator } from "./DropdownOptionHoverIndicator";
import type { CdropdownOption } from "./Cdropdown.types";
import { buildOptionButtonStyle, buildOptionHighlightStyle, } from "./dropdown-option-styles";
import type { DropdownOptionViewState } from "./option-state";
import { dataEl, type DataElScope } from "@/utils/dataEl";
interface DropdownOptionItemProps {
    dataElScope: DataElScope;
    option: CdropdownOption;
    index: number;
    viewState: DropdownOptionViewState;
    isAnimating: boolean;
    isClosing: boolean;
    onElementRef: (input: {
        index: number;
        element: HTMLDivElement | null;
    }) => void;
    onMouseEnter: (input: {
        index: number;
        isDisabled: boolean;
    }) => void;
    onMouseLeave: () => void;
    onClick: (option: CdropdownOption) => void;
}
export function DropdownOptionItem({ dataElScope, option, index, viewState, isAnimating, isClosing, onElementRef, onMouseEnter, onMouseLeave, onClick, }: DropdownOptionItemProps) {
    const optionIdentity = option.key ?? option.label;
    return (
    <div data-el={dataEl(dataElScope, "OptionItem/Root")} style={{ position: "relative", width: "100%" }}>
      <div data-el={dataEl(dataElScope, "OptionItem/Highlight")} style={buildOptionHighlightStyle(viewState)}/>

      <Cbutton
        rootRef={(element) => {
            onElementRef({ index, element });
        }}
        preset={ButtonPreset.Ghost}
        ariaLabel={option.label}
        ariaPressed={viewState.isSelected}
        padding={0}
        disabled={viewState.isDisabled}
        disableClickMotion
        onMouseEnter={() => {
            onMouseEnter({ index, isDisabled: viewState.isDisabled });
        }}
        onMouseLeave={onMouseLeave}
        onClick={() => {
            if (!viewState.isDisabled) {
                onClick(option);
            }
        }}
        style={{ width: "100%" }}
        containerStyle={{ ...buildOptionButtonStyle({ viewState, isAnimating, isClosing }), width: "100%" }}
      >
        {option.renderContent ? (option.renderContent({
            isActive: viewState.isHighlighted,
            isSelected: viewState.isSelected,
            isDisabled: viewState.isDisabled,
            index,
        })) : (<DropdownOptionDefaultContent dataElScope={dataElScope} option={option} viewState={viewState}/>)}

        {!option.hideHoverIndicator && (<DropdownOptionHoverIndicator dataElScope={dataElScope} isHighlighted={viewState.isHighlighted} isSelected={viewState.isSelected} optionIdentity={optionIdentity}/>)}
      </Cbutton>
    </div>
    );
}
